import { graphql } from '@eluve/graphql.tada';

import { tenantPendingApprovalFragment } from './TenantApprovalToggle';

export const getAdminTenantsSummaryFilterQuery = graphql(
  `
    query getAdminTenantSummaryFilter(
      $filter: AdminTenantsBoolExp
      $offset: Int
      $orderBy: [AdminTenantsOrderBy!]
      $limit: Int
    ) {
      adminTenants(
        where: $filter
        offset: $offset
        limit: $limit
        orderBy: $orderBy
      ) {
        __typename
        id
        name
        createdAt
        isPendingApproval
        appointmentCount
        userCount
        isCurrentUserProvisioned
        isRealTenant
        ...TenantPendingApproval
      }
      adminTenantsAggregate(where: $filter) {
        __typename
        aggregate {
          __typename
          count
        }
      }
    }
  `,
  [tenantPendingApprovalFragment],
);
